import cssjanus from 'cssjanus';
import {
  COMMENT,
  compile,
  DECLARATION,
  IMPORT,
  RULESET,
  serialize,
  strlen,
  KEYFRAMES,
  MEDIA,
  SUPPORTS,
} from 'stylis';

function stringifyPreserveComments(element) {
  switch (element.type) {
    case IMPORT:
    case DECLARATION:
    case COMMENT: {
      const value = element.return || element.value;
      element.return = value;
      return value;
    }
    case RULESET: {
      element.value = Array.isArray(element.props) ? element.props.join(',') : element.props;
      if (Array.isArray(element.children)) {
        element.children.forEach((child) => {
          if (child.type === COMMENT) child.children = child.value;
        });
      }
      break;
    }
    default:
      break;
  }
  const serializedChildren = serialize(
    Array.prototype.concat(element.children),
    stringifyPreserveComments
  );
  if (!strlen(serializedChildren)) return '';
  const wrapped = `${element.value}{${serializedChildren}}`;
  element.return = wrapped;
  return wrapped;
}

export default function stylisRTLPlugin(element) {
  if (
    element.type === KEYFRAMES ||
    element.type === SUPPORTS ||
    (element.type === RULESET &&
      (!element.parent || element.parent.type === MEDIA || element.parent.type === RULESET))
  ) {
    const stringified = cssjanus.transform(stringifyPreserveComments(element));
    element.children = stringified ? compile(stringified)[0].children : [];
    element.return = '';
  }
}

Object.defineProperty(stylisRTLPlugin, 'name', { value: 'stylisRTLPlugin' });
